<template>
  <div>
    <user-actions-component></user-actions-component>
    <section class="bg-white py-5" aria-label="Service details">
      <meta-data
        :id="service.id"
        :name="service.name"
        :type="service.service_taxonomys"
        :description="service.descritption"
        :image-prop="service.logo"
      ></meta-data>
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="12" md="12" lg="8">
            <h1 id="service-title" class="mb-3">{{ service.name }}</h1>
            <b-skeleton-wrapper v-if="!service.name">
              <b-skeleton height="2.4rem" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
              <b-skeleton height="10rem" animation="wave" width="70%"></b-skeleton>
            </b-skeleton-wrapper>
            <debug-bar :api-response="service"></debug-bar>
            <span v-if="service.name">
              <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
                <!-- service areas list -->
                <area-info
                  v-if="service.service_areas"
                  :list-array="service.service_areas"
                  value-name="service_area"
                  id-name="id"
                ></area-info>
                <div class="d-flex align-items-center flex-wrap">
                  <!-- share on socials -->
                  <social-actions :service="service"></social-actions>
                  <!-- save to favourites -->
                  <favourite-pop-up
                    :item-id="service.id"
                    :item-name="service.name"
                  ></favourite-pop-up>
                  <!-- download pdf -->
                  <b-button variant="link" class="card-link" @click="generatePdf()">
                    Download Pdf
                    <span class="small"><b-icon icon="file-earmark-arrow-down"></b-icon></span>
                  </b-button>
                </div>
              </div>
              <!-- service contact details -->
              <b-row class="bg-light mb-3">
                <b-col>
                  <basic-info id="basic-info" :data-item="service"></basic-info>
                </b-col>
              </b-row>
              <!-- service description -->
              <b-card-text id="service-description" v-html="service.description"> </b-card-text>
              <!-- venue details -->
              <b-row
                v-if="
                  service.service_at_locations &&
                  service.service_at_locations[0] &&
                  service.service_at_locations[0].location.latitude
                "
                class="bg-light py-4 px-2 my-4"
              >
                <b-col>
                  <h3 class="h5">Locations:</h3>
                  <div
                    v-if="
                      service.service_at_locations[0] &&
                      service.service_at_locations[0].location.latitude
                    "
                    class="single-service-map"
                  >
                    <map-component :serv="[service]" :expand="true" sm="12" class="mb-4" />
                  </div>
                  <!--
                    <location-info :locations="service.service_at_locations"></location-info>
                  -->
                  <!-- session times -->
                  <div id="service-times">
                    <service-times :service="service"></service-times>
                  </div>
                </b-col>
              </b-row>
              <!-- service types list -->
              <b-row
                v-if="service.service_taxonomys && service.service_taxonomys.length > 0"
                class="bg-light py-4 px-2 my-4"
              >
                <b-col>
                  <h3 class="mb-3 h5">This service provides support around</h3>
                  <list-info
                    v-if="service.service_taxonomys"
                    :list-array="service.service_taxonomys"
                    value-name="name"
                    id-name="id"
                    parent-name="taxonomy"
                  ></list-info>
                </b-col>
              </b-row>
              <!-- service provider contact details -->
              <b-row class="bg-light mb-3">
                <b-col>
                  <div class="service-provider-contact py-4 px-3">
                    <h3 class="h5">Service provider</h3>
                    <organisation-info :data-item="service"></organisation-info>
                  </div>
                </b-col>
              </b-row>
            </span>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import store from '@/store/'
import { mapGetters } from 'vuex'
import { FETCH_SERVICE } from '@/store/actions.type.js'

import scrollMixin from '../mixin/scroll-mixins'

import DebugBar from '@/components/DebugBar'
import ListInfo from '@/components/elements/ListInfo'
import AreaInfo from '@/components/elements/AreaInfo'
import MapComponent from '@/components/map/MapComponent'
import ServiceTimes from '@/components/elements/ServiceTimes'
import BasicInfo from '@/components/elements/BasicInfo'
import OrganisationInfo from '@/components/elements/OrganisationInfo'
import FavouritePopUp from '@/components/favourite_list/FavouritePopUp'
import BackButton from '@/components/elements/BackButton'
import SocialActions from '@/components/elements/SocialActions.vue'
import MetaData from '@/components/elements/MetaData.vue'
import UserActionsComponent from './elements/UserActionsComponent.vue'

export default {
  name: 'Service',
  components: {
    DebugBar,
    ListInfo,
    AreaInfo,
    MapComponent,
    ServiceTimes,
    BasicInfo,
    OrganisationInfo,
    FavouritePopUp,
    BackButton,
    SocialActions,
    MetaData,
    UserActionsComponent,
  },
  mixins: [scrollMixin],
  computed: {
    ...mapGetters(['service']),
  },
  mounted() {
    this.scrollToElement('#app')
    store.dispatch(FETCH_SERVICE, this.$router.history.current.params.id)
  },
  methods: {
    generatePdf() {
      // Header
      const { jsPDF } = require('jspdf')
      let pdfBuild = {}
      let serviceTimes = ''
      let serviceProvider = ''
      let doc = new jsPDF()
      doc.setFont(undefined, 'normal')

      const serviceTitle = document
        .getElementById('service-title')
        .outerHTML.replace(/(<([^>]+)>)/gi, '')
        .replace('&nbsp;', ' ')
        .replace('&amp;', '&')

      doc.setFontSize('15')
      doc.text(15, 15, serviceTitle)

      // Contact
      let basicInfo = ''
      if (document.getElementById('service-website')) {
        let websiteInfoEl = document.getElementById('service-website')
        const webUrl = websiteInfoEl.querySelector('a').href
        basicInfo += `Website:\n${webUrl}\n`
      }
      if (document.getElementById('service-email')) {
        const emailInfoEl = document.getElementById('service-email')
        const emailUrl = emailInfoEl.querySelector('a').href.replace('mailto:', '')
        basicInfo += `Email:\n${emailUrl}\n`
      }

      if (
        document.getElementById('service-phone') &&
        document.getElementById('service-phone').childElementCount > 0
      ) {
        const phoneInfo = document
          .getElementById('service-phone')
          .outerHTML.replace(/<a[^>]*>/gi, '')
          .replace(/<\/a>/g, '\n')
          .replace('</span>', ' ')
        basicInfo += `Phone:\n${phoneInfo}`
      }

      // Content
      const serviceDescription = document
        .getElementById('service-description')
        .outerHTML.replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/<h[^>]*>/gi, '\n')
        .replace(/<\/h[0-9]>/gi, '\n')

      if (document.getElementById('service-times')) {
        serviceTimes = document
          .getElementById('service-times')
          .outerHTML.replace(/ View location information /, '')
          .replace('Add this session to my calendar ', '\n')
          .replace(/<address>/, '\n')
      }

      if (document.getElementById('service-provider')) {
        serviceProvider = '\nService provider\n'
        serviceProvider += document.getElementById('service-provider').outerHTML
      }

      const serviceMarkup =
        basicInfo +
        '<br/><br/>' +
        serviceDescription +
        '<br/>' +
        serviceTimes +
        '<br/>' +
        serviceProvider

      const serviceText = serviceMarkup
        .replace(/<br\s*[\/]?>/gi, '\n')
        .replace(/<\/p\s*[\/]?>/gi, '\n')
        .replace(/<li\s*[\/]?>/gi, '\n-')
        .replace(/<\/ul>/gi, '\n')
        .replace(/(<([^>]+)>)/gi, '')

      let splitText = doc.splitTextToSize(serviceText, 180)

      doc.setFontSize('11')
      var y = 30

      pdfBuild = this.pdfLines(y, splitText, doc)
      pdfBuild.doc.save(serviceTitle + '.pdf')
    },
    pdfLines(y, splitText, doc) {
      for (var i = 0; i < splitText.length; i++) {
        if (y > 280) {
          y = 10
          doc.addPage()
        }
        doc.text(15, y, splitText[i])
        y = y + 7
      }
      return { y: y, doc }
    },
  },
}
</script>
